
  window.collectEvent('init', {
    app_id: ["sit","uat","ver", "localhost"].some(i=>location.host.includes(i)) ? 10000703 : 10000700,
    channel_domain:  location.host.startsWith('localhost')? '/datafinder' : 'https://iotsdk.midea.com',
    // disable_auto_pv: true,
    log: false, // true:开启日志，false:关闭日志
    autotrack: false, // 全埋点开关，true开启，false关闭
    enable_stay_duration: true, // 开启停留时长
    enable_debug: false,
    spa: true,
    allow_hash: true
  });
  window.collectEvent('start'); // 通知SDK设置完毕，可以真正开始发送事件了
  